import { render, staticRenderFns } from "./InstallPrompt.vue?vue&type=template&id=16a3767c&scoped=true"
import script from "./InstallPrompt.vue?vue&type=script&lang=js"
export * from "./InstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./InstallPrompt.vue?vue&type=style&index=0&id=16a3767c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../var/www/frontend-radio-preview-src/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.95.0__lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.95.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3767c",
  null
  
)

export default component.exports